import { isArray } from 'util';
import { parseNumber } from '../../utils/number.utils';
import { ManufacturingOrder } from '../manufacturing-order';
import { RegisteredManufacturingOrder } from '../registered-manufacturing-order';
import { RegisteredProjectNumber } from '../registered-project-number';
import { ArticleVersionBuilder } from './article-version.builder';
import { ClientBuilder } from './client.builder';
import { MaterialBuilder } from './material.builder';

export class ManufacturingOrderBuilder {
  static fromJson(json) {
    return json
      ? new ManufacturingOrder(
          json.hash,
          json.code,
          json.project,
          json.customer,
          json.subCustomer,
          json.reference,
          json.observations,
          parseNumber(json.lastSynchronization),
          json.materials ? MaterialBuilder.fromList(json.materials) : null,
          json.planeLink,
          json.projectNumber,
          json.manufacturingOrderFeature,
          json.manufacturingOrderIncidence,
          json.manufacturingOrderFile,
          json.situation,
          parseNumber(json.deliveryDate),
          json.entryNumber,
          json.existsPDF,
          json.routeCode,
          json.mainManufacturingOrder,
          parseNumber(json.quantity),
          json.articleVersion
            ? ArticleVersionBuilder.fromJson(json.articleVersion)
            : null,
          json.client ? ClientBuilder.fromJson(json.client) : null,
          json.articleNumber,
          json.articleHash,
          parseNumber(json.latheDate),
          json.mpReady,
          json.hasMaterialReady,
          json.hasMaterialInStock,
          json.isClaimed,
          json.isDeliveryChanged,
          json.isUrgent,
          json.timeDays,
          json.hasMaterialEdited,
          json.plannerObservations,
          json.hasQuantityEdited,
          json.hasDeliveryDateEdited,
          json.blocked
        )
      : null;
  }

  static fromList(list) {
    return isArray(list) ? list.map(ManufacturingOrderBuilder.fromJson) : [];
  }

  static buildRegisteredManufacturingOrderFromJson(json) {
    return json ? new RegisteredManufacturingOrder(json.code) : null;
  }

  static buildRegisteredManufacturingOrderFromList(list) {
    return isArray(list)
      ? list.map(
          ManufacturingOrderBuilder.buildRegisteredManufacturingOrderFromJson
        )
      : [];
  }

  static buildRegisteredProjectNumberFromJson(json) {
    return json ? new RegisteredProjectNumber(json.code) : null;
  }

  static buildRegisteredProjectNumberFromList(list) {
    return isArray(list)
      ? list.map(ManufacturingOrderBuilder.buildRegisteredProjectNumberFromJson)
      : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/manufacturing-order.builder.ts